"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WpConfigDeletedContract = void 0;
const events_1 = require("@getgreenline/events");
class WpConfigDeletedContract extends events_1.EventsV2.EventModels.EventContractV2 {
    constructor(params) {
        super(params);
    }
}
exports.WpConfigDeletedContract = WpConfigDeletedContract;
//# sourceMappingURL=WpConfigDeletedContract.js.map